import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { RootState } from '../../../../redux/store';
import { PageContainer, PageSection } from '../../../../ui';
import { colors } from '../../../../theme/tokens';
import Personal from './Personal';
import Devices from './Devices';
import Browsers from './Browsers';
import Finance from './Finance';

const tabs = [
  { key: 'personal', label: 'Personal', component: Personal },
  { key: 'devices', label: 'Devices', component: Devices },
  { key: 'browsers', label: 'Browsers', component: Browsers },
  { key: 'finance', label: 'Finance', component: Finance },
];

/* Tester → Profile. The tab is part of the URL (/account/tester/myprofile/:tab), so other pages can link to e.g. devices. */
const MyProfile: React.FC = () => {
  const { tab } = useParams<{ tab?: string }>();
  const history = useHistory();
  const { resolution } = useSelector((state: RootState) => state);
  const isMobile = resolution.device === 'mobile' || resolution.device === 'mobile-tablet';

  const activeIndex = Math.max(0, tabs.findIndex((item) => item.key === tab));
  const Active = tabs[activeIndex].component;

  return (
    <PageContainer isMobile={isMobile}>
      <PageSection padding={isMobile ? 1.5 : 2.5}>
        <Tabs
          value={activeIndex}
          onChange={(_, index) => history.push(`/account/tester/myprofile/${tabs[index].key}`)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: `1px solid ${colors.dividerBlue}`, mb: 2.5 }}
        >
          {tabs.map((item) => (
            <Tab key={item.key} label={item.label} sx={{ textTransform: 'none', minHeight: 44 }} />
          ))}
        </Tabs>
        <Active />
      </PageSection>
    </PageContainer>
  );
};

export default MyProfile;
